export default __webpack_public_path__ + "static/media/ChronoCheck.1bf28dd2fe561a264c415a8d90b0578d.webp";